import { definePage } from '@reflex/plugin-api/web';
import type { PluginWebManifest } from '@reflex/plugin-api/web';

const page = definePage({
  path: '/axons',
  label: 'Axons',
  icon: 'Radio',
  group: 'plugins',
  componentPath: '@reflex/plugin-axon-viewer/web/AxonListPage',
  description: 'Real-time event streams.',
  details:
    'Axons are the event bus that connects agents to the outside world. Each running agent publishes structured events — progress updates, tool calls, completions — to its own Axon stream. The server subscribes via SSE and pushes events to clients over WebSocket in real time.',
  features: [
    'Per-agent streams',
    'Structured event types',
    'SSE + WebSocket delivery',
    'Full event history',
  ],
});

export const axonWeb: PluginWebManifest = {
  ...page.web,
  routes: [
    ...page.web.routes!,
    {
      path: '/axons/:axonId',
      componentPath: '@reflex/plugin-axon-viewer/web/AxonDetailPage',
    },
  ],
  agentTabs: [
    {
      id: 'axon',
      label: 'Axon',
      icon: 'Radio',
      componentPath: '@reflex/plugin-axon-viewer/web/AxonAgentTab',
    },
  ],
};
